import { z } from 'zod'
import { Counterparty } from '~/shared/api/counterparty'
import { StsDocumentAttributes } from '~/shared/api/stsDocument'
import { buildI18nMessage } from '~/shared/lib/i18nMessageHelper'
import {
  dateSchema,
  priceRequiredScheme,
  stringRequiredScheme,
  uuidOptionSchema,
} from '~/shared/lib/schemas'
import { Car } from './car'
import { ApiModel, ToOneRelation } from './core'

const relationsSchema = z.object({
  counterpartyId: uuidOptionSchema,
})

const attributeSchema = z.object({
  series: stringRequiredScheme,
  number: stringRequiredScheme.refine(
    (value) => /^\d*$/.test(value),
    buildI18nMessage('validate.numbers only'),
  ),
  issuedDate: dateSchema,
  expirationDate: dateSchema,
  premium: priceRequiredScheme,

  files: z
    .object({
      id: z.string(),
      name: z.string(),
      filepath: z.string().url(),
      preview: z.string().url(),
    })
    .array()
    .optional(),
})

const schema = z
  .object({
    createdAt: dateSchema,
    updatedAt: dateSchema.optional(),
  })
  .merge(attributeSchema)
  .merge(relationsSchema)

export type OsagoDocumentAttributes = z.infer<typeof schema>

export class OsagoDocument extends ApiModel<typeof schema> {
  static jsonApiType = 'osago-documents'

  static schema = schema

  setCar(id: UniqueId) {
    this.setRelation('car', new Car({}, id))
  }

  getCreatedAt(): string {
    return this.getAttribute('createdAt')
  }

  getFiles(): StsDocumentAttributes['files'] {
    return this.getAttribute('files')
  }

  counterparty(): ToOneRelation<Counterparty, this> {
    return this.hasOne(Counterparty)
  }
  getCounterparty(): Counterparty {
    return this.getRelation('counterparty')
  }
  setCounterparty(id: UniqueId) {
    const region = new Counterparty()
    region.setApiId(id)
    this.setRelation('counterparty', region)
  }
}
